export default __webpack_public_path__ + "static/media/Vambraces of the Victorious Elite.a5197dc0.jpg";